import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import {
  DataContextBuilder,
  ElderDataToolbarComponent,
  ElderTableComponent,
  ElderTableToolbarDirective,
  IDataContext,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { Property } from '../../../../properties/property'
import { PropertyService } from '../../../../properties/property.service'

@Component({
  selector: 'app-display-property-browser',
  templateUrl: './display-property-browser.component.html',
  styleUrls: ['./display-property-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    ElderTranslatePipe,
  ],
})
export class DisplayPropertyBrowserComponent implements OnInit, OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly propertyConfig$ = new BehaviorSubject<string[]>([])

  public readonly data: IDataContext<Property>

  @Output()
  public readonly propertyConfigChange = new EventEmitter<string[]>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const propertyService = inject(PropertyService)
    this.data = new DataContextBuilder<Property>().build(propertyService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    this.data.start()
  }

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get propertyConfig(): string[] {
    return this.propertyConfig$.getValue()
  }

  @Input()
  public set propertyConfig(ppc: string[]) {
    this.propertyConfig$.next(ppc)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onSelectionChange(pps: Property[]) {
    this.propertyConfig = pps.map((pp) => (pp.id ? pp.id : pp.toString()))
    this.propertyConfigChange.emit(this.propertyConfig)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
